"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetCopy = void 0;
const unauthKeys = {
  header: 'session_expired.modal.title',
  content: 'session_expired.modal.text',
  button: 'session_expired.modal.cta'
};
const getWidgetCopy = ({
  status,
  error
}) => {
  if (status === 401) return unauthKeys;
  switch (error.error_code) {
    default:
      return {};
  }
};
exports.getWidgetCopy = getWidgetCopy;